import Vue from 'vue'
import { Row, Col, Carousel, CarouselItem } from 'element-ui'

Vue.component('l-row', Row)
Vue.component('l-col', Col)
Vue.component('l-carousel', Carousel)
Vue.component('l-carousel-item', CarouselItem)